import React from "react";
import Routes from "./Routes";
import "antd/dist/antd.css";

const App = () => <Routes />;

export default App;
